export const isEnum = (type: string) => type.startsWith('Enum') || type.startsWith('SliceOfEnum')

export const isSliceOfEnum = (type: string) => type.startsWith('SliceOfEnum')
